import { PropertiesInterface } from "@api/models/settings/PropertiesInterface";
import { customAlphabet, nanoid } from 'nanoid';

const getUnicCode = (generator: () => string, codes: Set<string>) => {
    let code;
    while (!code || codes.has(code)) {
        code = generator();
    }

    codes.add(code);

    return code;
}

export const getCodeGenerator = (codes?: Set<string>, userCodeSettings?: PropertiesInterface) => {
    if (codes) {
        const UNKNOW_PREFIX = 'unknown_prefix';

        if (userCodeSettings) {
            const { codeAlphabet, codeRandomLen, codePrefix = UNKNOW_PREFIX } = userCodeSettings

            if (codeAlphabet && codeRandomLen) {
                const length = parseInt(codeRandomLen);

                const generator = customAlphabet(codeAlphabet, isNaN(length) ? 6 : length);

                return () => {
                    return codePrefix + getUnicCode(generator, codes);
                }
            }
            else {
                return () => {
                    return codePrefix + getUnicCode(nanoid, codes);
                }
            }
        }
        else {
            return () => {
                return UNKNOW_PREFIX + getUnicCode(nanoid, codes);
            }
        }
    }
    else {
        return null;
    }
}